import React from "react";

export default function LinkExternal({ children, to, color = "#FFFFFF" }) {
  return (
    <a href={to} style={{ textDecoration: "none", color }}>
      {children}
    </a>
  );
}
